import React, {
  useState, useEffect, useContext, useCallback,
} from 'react';

import Calendar from '../../../../../../components/Calendar';
import { PageContext } from '../../../../context';
import { ContentContext } from '../../context';
import { LPTitle, LPText } from '../../../../../styles';

const ServiceDatesSlider = () => {
  const {
    formData: { serviceDay },
    selectServiceDate,
  } = useContext(PageContext);

  const {
    contextData: {
      queryError, queryData, selectedDate, handleChangeDate,
    },
  } = useContext(ContentContext);

  const [datesList, setDatesList] = useState([]);
  const handleDateClick = useCallback(
    (day) => {
      selectServiceDate(day);
      handleChangeDate(day);
    },
    [selectServiceDate, handleChangeDate],
  );

  useEffect(() => {
    const data = queryData || { availableTimeSlots: [] };
    const { availableTimeSlots } = data;
    const allDates = availableTimeSlots.edges || [];
    setDatesList(
      allDates.map(({ day, timeSlots }) => ({
        day,
        isSelected: day === serviceDay,
        items: timeSlots || [],
      })),
    );
  }, [queryData, serviceDay]);

  const handleChangeMonth = useCallback(
    (newDate) => {
      handleChangeDate(newDate);
    },
    [handleChangeDate],
  );

  if (queryError) {
    return (
      <>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <LPText>{queryError.message}</LPText>
      </>
    );
  }

  return (
    <Calendar
      date={selectedDate}
      onDaySelect={handleDateClick}
      onChangeMonth={handleChangeMonth}
      activeDays={datesList}
      isOpen
    />
  );
};

ServiceDatesSlider.propTypes = {};

export default ServiceDatesSlider;
